<template>
  <v-app id="inspire">
    <v-content class="login-wrapper">
      <v-container fluid fill-height>
        <v-layout align-center justify-center>
          <v-flex xs12 sm8 md4>
            <v-card class="elevation-12">
            <v-progress-linear :indeterminate="true" v-if="isLoading" class="login"/>
              <v-card-text>
                <v-form>
                  <v-text-field
                    v-model="username"
                    name="login"
                    label="Login"
                    :error="hasError"
                    type="text"
                    class="input-group--focused"
                    autofocus
                    v-on:keyup.enter="login"
                    />
                  <v-text-field
                    v-model="password"
                    name="password"
                    label="Password"
                    id="password"
                    :error="hasError"
                    type="password"
                    v-on:keyup.enter="login"
                    />
                </v-form>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="primary" @click="login">Login</v-btn>
              </v-card-actions>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
    </v-content>
  </v-app>
</template>

<script>
export default {
  computed: {
    isLoading () { return this.$store.getters['auth/isLoading'] },
    authError () { return this.$store.getters['auth/authError'] },
    hasError () { return this.$store.getters['auth/hasError'] },
    isLoggedOff () { return !this.$store.getters['auth/userLoggedIn'] },
  },

  data () {
    return {
      username: '',
      password: '',
    }
  },
  methods: {
    clearForm () {
      this.username = ''
      this.password = ''
    },
    login () {
      let creds = {username: this.username, password: this.password}
      this.$store.dispatch('auth/login', creds)
        .then(() => {
          this.$router.push({path: this.redirect})
        })
        .catch(() => {
        // pass
        })
    },
  },
  props: {
    redirect: {
      type: String,
      default: '/',
    },
  },
}
</script>
<style>
.content.login-wrapper .content--wrap {
  background: url('/static/img/login_bg.jpg') no-repeat center center fixed !important;
  background-size: cover !important;
}
.v-progress-linear {
  margin: 0 !important;
}
</style>
